package com.tovtalk.utils.strings

/**
 * Replaces {days} placeholder in translation strings (e.g. "ניתן לנסות שוב בעוד {days} ימים").
 * Used for verification retry messages where the API returns retry_days_remaining.
 */
fun String.replaceDays(days: Int): String = replace("{days}", days.toString())
